import { useTranslation } from "react-i18next";
import { LogoutIcon, MenuItem, LoadingIcon } from "melco-ui";

type LogoutMenuItemProps = {
  key: string;
  isLoggingOut: boolean;
};

const LogoutMenuItem: React.FC<LogoutMenuItemProps> = ({
  isLoggingOut,
  ...rest
}) => {
  const { t } = useTranslation();

  return (
    <MenuItem
      icon={isLoggingOut ? <LoadingIcon spin /> : <LogoutIcon />}
      disabled={isLoggingOut}
      {...rest}
    >
      {t("logout.menuTitle", { ns: "melco-common" })}
    </MenuItem>
  );
};

export default LogoutMenuItem;
